var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPenAltSolid = function SvgPenAltSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3004 3.26502L12.7351 1.6997C12.2469 1.21143 11.4549 1.21143 10.9667 1.6997L9.49406 3.17232L12.8278 6.50608L14.3004 5.03346C14.7887 4.5452 14.7887 3.75355 14.3004 3.26502ZM7.87353 2.7304C7.46677 2.32364 6.80741 2.32364 6.40065 2.7304L3.3075 5.82381C3.14475 5.98656 3.14475 6.25036 3.3075 6.41286L3.89681 7.00216C4.05957 7.16492 4.32336 7.16492 4.48612 7.00216L7.13761 4.35067L7.72692 4.93972L3.78015 8.88623C2.41308 10.2533 1.55185 12.0448 1.33802 13.9663L1.33724 13.9723C1.29297 14.3702 1.62916 14.7067 2.02707 14.6626C3.95101 14.4502 5.74518 13.5887 7.11391 12.22L12.2385 7.09539L10.0831 4.93998L7.87353 2.7304Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPenAltSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pen_alt_solid.bdc7aece.svg";
export { ForwardRef as ReactComponent };